// "Download RO-Crate": GET /api/{datasets|studies|projects}/{id}/export/ro-crate through
// api.download (the RO-Crate 1.2 zip with the file bytes embedded; backend/unio/routers/rocrate.py).
// Props: { kind: "datasets" | "studies" | "projects", id, filename }
import { useState } from "react";
import { api } from "../api";
import { ErrorNote } from "./Feedback";
import { Btn } from "./Shared";

export default function RoCrateButton({ kind, id, filename }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const download = async () => {
    setError(null);
    setBusy(true);
    try {
      await api.download(`/${kind}/${id}/export/ro-crate`, filename);
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  };
  return (
    <span style={{ display: "inline-flex", flexDirection: "column", gap: 6 }}>
      <Btn variant="secondary" onClick={download} disabled={busy}>Download RO-Crate</Btn>
      <ErrorNote error={error} />
    </span>
  );
}
